import * as React from "react";

import FAQContainer from "~/containers/FAQ/FAQContainer";
import SupportDashboardLayout from "~/layouts/SupportDashboardLayout";

export default class FAQIndex extends React.Component {
  public render() {
    return (
      <SupportDashboardLayout>
        <FAQContainer />
      </SupportDashboardLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FAQ/FAQIndex.tsx